// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { User } from "./User";
import { UserFromJSON, UserFromJSONTyped, UserToJSON, UserToJSONTyped } from "./User";
import type { RelatedEntity } from "./RelatedEntity";
import {
  RelatedEntityFromJSON,
  RelatedEntityFromJSONTyped,
  RelatedEntityToJSON,
  RelatedEntityToJSONTyped,
} from "./RelatedEntity";

/**
 *
 * @export
 * @interface ApiKeyRead
 */
export interface ApiKeyRead {
  /**
   *
   */
  id: string;
  /**
   *
   */
  createdAt: Date;
  /**
   *
   */
  updatedAt: Date;
  /**
   *
   */
  creator: User;
  /**
   *
   */
  name: string;
  /**
   *
   */
  revoked: boolean;
  /**
   *
   */
  expiresAt: Date | null;
  /**
   *
   */
  scope: Set<string>;
  /**
   *
   */
  relatedTo: RelatedEntity;
}

/**
 * Check if a given object implements the ApiKeyRead interface.
 */
export function instanceOfApiKeyRead(value: object): value is ApiKeyRead {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (
    (!("createdAt" in (value as Record<string, any>)) &&
      !("created_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["createdAt"] === undefined &&
      (value as Record<string, any>)["created_at"] === undefined)
  )
    return false;
  if (
    (!("updatedAt" in (value as Record<string, any>)) &&
      !("updated_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["updatedAt"] === undefined &&
      (value as Record<string, any>)["updated_at"] === undefined)
  )
    return false;
  if (!("creator" in value) || value["creator"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("revoked" in value) || value["revoked"] === undefined) return false;
  if (
    (!("expiresAt" in (value as Record<string, any>)) &&
      !("expires_at" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["expiresAt"] === undefined &&
      (value as Record<string, any>)["expires_at"] === undefined)
  )
    return false;
  if (!("scope" in value) || value["scope"] === undefined) return false;
  if (
    (!("relatedTo" in (value as Record<string, any>)) &&
      !("related_to" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["relatedTo"] === undefined &&
      (value as Record<string, any>)["related_to"] === undefined)
  )
    return false;
  return true;
}

export function ApiKeyReadFromJSON(json: any): ApiKeyRead {
  return ApiKeyReadFromJSONTyped(json, false);
}

export function ApiKeyReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiKeyRead {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    createdAt: json["created_at"] == null ? json["created_at"] : parseDateTime(json["created_at"]),
    updatedAt: json["updated_at"] == null ? json["updated_at"] : parseDateTime(json["updated_at"]),
    creator: UserFromJSON(json["creator"]),
    name: json["name"],
    revoked: json["revoked"],
    expiresAt: json["expires_at"] == null ? null : parseDateTime(json["expires_at"]),
    scope: new Set(json["scope"]),
    relatedTo: RelatedEntityFromJSON(json["related_to"]),
  };
}

export function ApiKeyReadToJSON(json: any): ApiKeyRead {
  return ApiKeyReadToJSONTyped(json, false);
}

export function ApiKeyReadToJSONTyped(
  value?: ApiKeyRead | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    updated_at:
      value["updatedAt"] == null ? value["updatedAt"] : serializeDateTime(value["updatedAt"]),
    creator: UserToJSON(value["creator"]),
    name: value["name"],
    revoked: value["revoked"],
    expires_at:
      value["expiresAt"] == null ? value["expiresAt"] : serializeDateTime(value["expiresAt"]),
    scope: Array.from(value["scope"] as Set<any>),
    related_to: RelatedEntityToJSON(value["relatedTo"]),
  };
}
